import HolderCard from './holder-card'
import HolderGrid from './holder-grid'

HolderGrid.Item = HolderCard

export default HolderGrid



// WEBPACK FOOTER //
// ./src/components/holder-grid/index.js